import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@客户-设备流量*/
import React from 'react';
import BossTable from "../../../../Common/BossTable";
import { parse } from "../../../../../utils/commonUtilFunc";
import { withRouter } from "react-router-dom";
import { connect } from "dva";
import { injectIntl } from "react-intl";
var Option = _Select.Option;
var UserFlowRankTab = /*#__PURE__*/function (_React$Component) {
  _inherits(UserFlowRankTab, _React$Component);
  function UserFlowRankTab(props) {
    var _this;
    _classCallCheck(this, UserFlowRankTab);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserFlowRankTab).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_users_dpi", function () {
      _this.props.dispatch({
        type: "ci0303Info/get_users_dpi",
        payload: {
          start_tm: _this.start_tm,
          end_tm: _this.end_tm,
          tunnel_dir: _this.tunnel_dir_id,
          sn: _this.sn,
          ids: _this.props.ids,
          top: _this.state.top,
          sip: _this.state.name,
          companyid: _this.ifCompany ? _this.id : sessionStorage.getItem("companyId")
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        top: value
      }, function () {
        vm.get_users_dpi();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchInputChange", function (e) {
      _this.setState({
        name: e.target.value.replace(/(^\s*)|(\s*$)/g, "")
      });
    });
    _this.state = {
      name: "",
      top: "5"
    };
    var search = parse(_this.props.location.search);
    _this.sn = search.sn;
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir_id = search.tunnel_dir_id;
    _this.id = search.id;
    _this.ifCompany = sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(UserFlowRankTab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_users_dpi();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var columns = [{
        title: "User IP Address",
        dataIndex: 'sip',
        key: 'sip'
      }, {
        title: "MAC address",
        dataIndex: 'mac',
        key: 'mac'
      }, {
        title: "Traffic MB",
        dataIndex: 'flow',
        key: 'flow',
        render: function render(text) {
          return (text / 1024 / 1024).toFixed(4);
        }
      }, {
        title: "Proportion of traffic (%)",
        dataIndex: 'percent',
        key: 'percent',
        render: function render(text, record) {
          return (record.flow / 1024 / 1024 / _this2.props.flow * 100).toFixed(2);
        }
      }];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select the number of data entries",
        style: {
          width: 120,
          marginRight: 8,
          marginTop: 16
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "5 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "10 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "15 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "20 articles")), /*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter keywords",
        style: {
          width: 240,
          marginRight: 8
        },
        className: "input",
        onChange: this.handleSearchInputChange
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.get_users_dpi
      }, "search"), /*#__PURE__*/React.createElement(BossTable, {
        columns: columns,
        style: {
          marginTop: 16
        },
        dataSource: this.props.ci0303Info.userFlowRankTableDataSource
      }));
    }
  }]);
  return UserFlowRankTab;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(injectIntl(UserFlowRankTab)));